export default __webpack_public_path__ + "static/media/handling.ce4f87a7.svg";